module.exports = __webpack_public_path__ + "static/media/KaTeX_Main-Bold.0ba875a1.woff";